import {createContext} from 'react';

export const SiteUpdate = createContext({});

export default createContext({});